var Role;
(function (Role) {
    Role[Role["Reader"] = 1] = "Reader";
    Role[Role["Member"] = 2] = "Member";
    Role[Role["SettingsOnly"] = 3] = "SettingsOnly";
    Role[Role["Approver"] = 4] = "Approver";
    Role[Role["Admin"] = 5] = "Admin";
    Role[Role["System"] = 6] = "System";
})(Role || (Role = {}));
const Roles = {
    Reader: Role.Reader,
    Member: Role.Member,
    SettingsOnly: Role.SettingsOnly,
    Approver: Role.Approver,
    Admin: Role.Admin,
    System: Role.System,
};

function justText(value) {
    if (!value)
        return value;
    return value.replace(/\W/g, "").toLowerCase();
}
function isString(data) {
    if (data === undefined)
        return data;
    if (data === null)
        return data;
    return typeof data === "string";
}
function afterLast(value, delimiter) {
    if (!value)
        return value;
    if (!delimiter)
        return value;
    const lastPos = value.lastIndexOf(delimiter);
    if (lastPos < 0)
        return null;
    return value.substring(lastPos + delimiter.length);
}
function beforeLast(value, delimiter) {
    if (!value)
        return value;
    if (!delimiter)
        return value;
    const lastPos = value.lastIndexOf(delimiter);
    if (lastPos < 0)
        return null;
    return value.substring(0, lastPos);
}
function isNullOrEmptyOrWhitespace(value) {
    if (!value)
        return true;
    if (typeof value == "string" && value.match(/^\s*$/))
        return true;
    return false;
}
function replaceSuffix(value, suffix, replaceWith) {
    if (!value)
        return value;
    if (!suffix)
        return value;
    if (value.endsWith(suffix)) {
        value = value.substring(0, value.length - suffix.length) + replaceWith;
    }
    return value;
}
function format(template, o) {
    return template.replace(/{([^{}]*)}/g, function (a, b) {
        var r = o[b];
        return typeof r === "string" || typeof r === "number" ? r : a;
    });
}

var mime$1 = require("mime-types");
function getEntityS3ObjectInfo(bucket, key, versionId = undefined) {
    const parts = key.split("/"); // [periodEnd/1234/Invoices/file.name]
    const entityType = parts.shift();
    const entityId = parseInt(parts.shift());
    const name = parts.pop();
    let type = afterLast(name, ".")?.toLowerCase() || "folder";
    const mimeType = mime$1.lookup(type);
    if (!mimeType)
        type = "folder";
    const folder = parts[0];
    return {
        entityType,
        entityId,
        folder,
        s3: `s3://${bucket}/${key}${versionId ? `?versionId=${versionId}` : ""}`,
        bucket,
        key,
        name,
        type,
        mimeType,
        versionId,
    };
}

const https = require("https");
const { CognitoIdentityProviderClient, InitiateAuthCommand } = require("@aws-sdk/client-cognito-identity-provider");
const crypto = require("crypto");
const HEADERS = {
    CORS: {
        "Access-Control-Allow-Headers": "Content-Type,Authorization,X-Amz-Date,X-Api-Key,X-Amz-Security-Token",
        "Access-Control-Allow-Methods": "DELETE,GET,HEAD,OPTIONS,PATCH,POST,PUT",
        // "Access-Control-Allow-Origin": "*", --this should be added by CORS config in AWS
    },
};
const RESPONSES = {
    UNAUTHENTICATED: { statusCode: 401, body: "Unauthenticated", headers: HEADERS.CORS },
    FORBIDDEN: { statusCode: 403, body: "Forbidden", headers: HEADERS.CORS },
    METHOD_NOT_ALLOWED: { statusCode: 405, body: "Method not allowed", headers: HEADERS.CORS },
    SERVER_ERROR: error => ({
        statusCode: 500,
        headers: HEADERS.CORS,
        body: JSON.stringify(error),
    }),
    BAD_REQUEST: (message = "Bad request") => ({ statusCode: 400, body: message, headers: HEADERS.CORS }),
    NOT_FOUND: (message = "Not found") => ({ statusCode: 404, body: message, headers: HEADERS.CORS }),
    OK: payload => ({
        statusCode: 200,
        headers: HEADERS.CORS,
        body: JSON.stringify(payload),
    }),
    HEAD: headers => ({
        statusCode: 200,
        headers: { ...HEADERS.CORS, ...headers },
        body: headers,
    }),
    OPTIONS: options => ({
        statusCode: 200,
        headers: { ...HEADERS.CORS, Allow: options.join(",") },
        body: options.join(","),
    }),
    ASYNC: async (payloadPromise) => {
        try {
            const payload = await payloadPromise;
            console.info(payload, "OK");
            return RESPONSES.OK(payload);
        }
        catch (err) {
            console.error(err);
            return RESPONSES.SERVER_ERROR("Error");
        }
    },
};
async function getAuthToken(credentials) {
    const hasher = crypto.createHmac("sha256", credentials.clientSecret);
    hasher.update(credentials.username + credentials.clientId);
    const secretHash = hasher.digest("base64");
    const client = new CognitoIdentityProviderClient({ region: "eu-west-2" });
    const command = new InitiateAuthCommand({
        AuthFlow: "USER_PASSWORD_AUTH",
        ClientId: credentials.clientId,
        AuthParameters: {
            USERNAME: credentials.username,
            PASSWORD: credentials.password,
            SECRET_HASH: secretHash,
        },
    });
    const resp = await client.send(command).then(data => {
        return {
            statusCode: 200,
            body: data,
        };
    });
    return resp.body.AuthenticationResult.IdToken;
}
// options: {
// 	hostname: api.hostname,
// 	port: 443,
// 	path: api.path,
// 	method: api.method,
// 	mode: "cors",
// 	headers: {
// 		Authorization: `Bearer ${token}`,
// 		"X-Api-Key": "clearview-customer-restapi-fetch",
// 		Accept: "application/json",
// 		"X-Clearview-Request": api.method + "|" + api.path,
// 	},
// }
async function doRequest(options, data = undefined) {
    return await new Promise((resolve, reject) => {
        const req = https.request(options, res => {
            res.setEncoding("utf8");
            let responseBody = "";
            res.on("data", chunk => {
                responseBody += chunk;
            });
            res.on("end", () => {
                try {
                    resolve(JSON.parse(responseBody));
                }
                catch {
                    resolve(responseBody);
                }
            });
        });
        req.on("error", err => {
            reject(err);
        });
        if (data)
            req.write(data);
        req.end();
    });
}

function randomPassword() {
    const uppercase = pickRandom("ABCDEFGHKLMNPRSTUVWXYZ", 3);
    const lowercase = pickRandom("abcdefghiklmnprstuvwxyz", 3);
    const numbers = pickRandom("123456789", 2);
    const special = pickRandom("$&()@!", 1);
    return shuffle(uppercase + lowercase + numbers + special);
}
function pickRandom(source, count, distinct = false) {
    if (distinct && source.length <= count)
        throw "When distinct is true, pickRandom count must be less than source length.";
    let rando = "";
    while (rando.length < count) {
        const randomIndex = Math.floor(Math.random() * source.length);
        const randum = source.charAt(randomIndex);
        if (!distinct)
            rando += randum;
        else if (rando.indexOf(randum) < 0)
            rando += randum;
    }
    return rando;
}
function shuffle(source) {
    const arr = source.split("");
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr.join("");
}

function toISODate(value) {
    return value?.toLocaleDateString("af");
}
function firstDateIn(values) {
    return values.map(it => stringToDate(it)).find(it => it);
}
function stringToDate(value) {
    const MONTH_NUMBERS = {
        JAN: 0,
        FEB: 1,
        MAR: 2,
        APR: 3,
        MAY: 4,
        JUN: 5,
        JUL: 6,
        AUG: 7,
        SEP: 8,
        OCT: 9,
        NOV: 10,
        DEC: 11,
        JANUARY: 0,
        FEBRUARY: 1,
        MARCH: 2,
        APRIL: 3,
        JUNE: 5,
        JULY: 6,
        AUGUST: 7,
        SEPTEMBER: 8,
        OCTOBER: 9,
        NOVEMBER: 10,
        DECEMBER: 11,
    };
    if (!value)
        return null;
    let match = value.match(/(\d{4})\W+(\d{2})\W+(\d{2})/);
    if (match)
        return new Date(+match[1], +match[2] - 1, +match[3]);
    match = value.match(/(\d+)\W+(\d+)\W+(\d{4})/);
    if (match)
        return new Date(+match[3], +match[2] - 1, +match[1]);
    match = value.match(/(\d+)\W+(\d+)\W+(\d{2})/);
    if (match)
        return new Date(2000 + +match[3], +match[2] - 1, +match[1]);
    match = value.match(/(\d{1,2}).+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|June|July|August|September|October|November|December)\W+(\d{4})/i);
    if (match)
        return new Date(+match[3], MONTH_NUMBERS[match[2].toUpperCase()], +match[1]);
    match = value.match(/(\d{1,2}).+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|June|July|August|September|October|November|December)\W+(\d{2})/i);
    if (match)
        return new Date(2000 + +match[3], MONTH_NUMBERS[match[2].toUpperCase()], +match[1]);
    match = value.match(/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|June|July|August|September|October|November|December)\W+(\d{1,2})\W+(\d{4})/i);
    if (match)
        return new Date(+match[3], MONTH_NUMBERS[match[1].toUpperCase()], +match[2]);
    match = value.match(/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|June|July|August|September|October|November|December)\W+(\d{1,2})\W+(\d{2})/i);
    if (match)
        return new Date(2000 + +match[3], MONTH_NUMBERS[match[1].toUpperCase()], +match[2]);
    return null;
}

var mime = require("mime-types");
function getFileName(path) {
    if (!path)
        return path;
    return afterLast(`/${path}`, "/");
}
function getFileType(path) {
    if (path?.length === 0)
        return null;
    if (!path)
        return path;
    var filename = afterLast(`/${path}`, "/");
    if (filename?.length === 0)
        return "folder";
    if (!filename)
        return filename;
    const type = afterLast(filename, ".");
    if (!type?.length)
        return "folder";
    return type.toLowerCase();
}
function getMimeType(path) {
    return mime.lookup(getFileType(path));
}
function asFolders(value) {
    if (!value)
        return null;
    return value.split("/").filter(it => it?.length);
}

function sleep(ms, beforeMessage = "Sleeping", afterMessage = "Waking") {
    return new Promise(resolve => {
        if (beforeMessage)
            console.info(`Sleep for ${ms}\t${beforeMessage}`);
        setTimeout(_ => {
            if (afterMessage)
                console.info(`Sleep for ${ms}\t${afterMessage}`);
            resolve();
        }, ms);
    });
}

function sequenceBy(...args) {
    return args.reduceRight((prevPredicate, propName) => {
        return (a, b) => {
            var path = propName.split(".");
            const getValue = obj => path.reduce((total, nodeName) => (total ? total[nodeName] : undefined), obj);
            const valA = getValue(a);
            const valB = getValue(b);
            return valA == valB ? prevPredicate(a, b) : valA < valB ? -1 : 1;
        };
    }, (a, b) => (a && b ? 0 : a ? -1 : 1));
}

const VENDOR_NAME_NOISE_WORDS = ["the", "and", "ltd", "limited", "llp", "plc", "uk", "group"];
/// Compares the two strings based on letter pair matches
/// Returns the percentage match from 0.0 to 1.0 where 1.0 is 100%
/// See http://www.catalysoft.com/articles/StrikeAMatch.html
/// This is more useful in our namespace where we are looking for Company Names that are likely to be spelled correctly,
/// but AWS Textract may only find part of the name
/// Considered:
/// 	Levenshtein distance - more useful for finding short words in long text
///		q-rams - more useful for spelling mistakes
///		Sørensen-Dice co-efficient - for similarities within sets
function stringCompare(string1, string2, noiseWords = []) {
    if ([null, undefined].includes(string1) || [null, undefined].includes(string2))
        return undefined;
    const pairs1 = wordLetterPairs(deClutter(string1, noiseWords));
    const pairs2 = wordLetterPairs(deClutter(string2, noiseWords));
    let intersection = 0;
    let union = pairs1.length + pairs2.length;
    if (union == 0)
        return 1;
    for (let i = 0; i < pairs1.length; i++) {
        for (let j = 0; j < pairs2.length; j++) {
            if (pairs1[i] == pairs2[j]) {
                intersection++;
                delete pairs2[j]; //Must remove the match to prevent "GGGG" from appearing to match "GG" with 100% success
                break;
            }
        }
    }
    return (2.0 * intersection) / union;
}
// StringCompare but as a boolean
function stringsMatch(string1, string2, noiseWords = []) {
    const compared = stringCompare(string1, string2, noiseWords);
    if (compared === undefined)
        return undefined;
    if (!compared)
        return false;
    if (compared < 1)
        return false;
    return true;
}
/// Convert to lower space, remove noise words and replace common punctuation with whitespace
function deClutter(str, noiseWords = []) {
    if (!str)
        return str;
    let res = str.toLowerCase();
    // Replace noise words
    for (let noiseWord of noiseWords) {
        const regex = new RegExp(`\\b${noiseWord}\\b`, "g");
        res = res.replace(regex, "");
    }
    //Replace punctuation and whitespace with single space
    res = res.replace(/\W+|\s+/g, " ");
    //Trim leading and trailing spaces
    return res.trim();
}
/// Gets all letter pairs for each
/// individual word in the string
function wordLetterPairs(str) {
    const allPairs = [];
    // Tokenize the string and put the tokens/words into an array
    const words = str.split(/\s/);
    // For each word
    for (let w = 0; w < words.length; w++) {
        if (!isNullOrEmptyOrWhitespace(words[w])) {
            // Find the pairs of characters
            const pairsInWord = letterPairs(words[w]);
            for (let p = 0; p < pairsInWord.length; p++) {
                allPairs.push(pairsInWord[p]);
            }
        }
    }
    return allPairs;
}
/// Generates an array containing every two consecutive letters in the input string
function letterPairs(str) {
    const pairs = [];
    if (str.length == 1)
        return [str];
    while (str.length > 1) {
        pairs.push(str.substring(0, 2));
        str = str.substring(1);
    }
    return pairs;
}

const HEADER_CELL_FORMAT = {
    font: {
        name: "arial",
        sz: 14,
        bold: true,
        color: {
            rgb: "FF00008B",
        },
    },
    alignment: {
        vertical: "center",
        horizontal: "center",
        wrapText: true,
    },
};
const CURRENCY_CELL_FORMAT = {
    numFmt: "£ 0.00;[Red]£ -0.00;\\-;@",
};
function formatColumns(worksheet, widths) {
    worksheet["!cols"] = widths.map(w => ({ hidden: typeof w === "boolean" ? w : false, wch: typeof w === "boolean" ? undefined : w }));
}
function formatRows(worksheet, heights) {
    worksheet["!rows"] = heights.map(h => ({ hidden: typeof h === "boolean" ? h : false, hpt: typeof h === "boolean" ? undefined : h }));
}
//For now only these columns are format-able
const AllColumns = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "AA",
    "AB",
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AH",
    "AI",
    "AJ",
    "AK",
    "AL",
    "AM",
    "AN",
    "AO",
    "AP",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AV",
    "AW",
    "AX",
    "AY",
    "AZ",
    "BA",
    "BB",
    "BC",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BK",
    "BL",
    "BM",
    "BN",
    "BO",
    "BP",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BU",
    "BV",
    "BW",
    "BX",
    "BY",
    "BZ",
];
function formatCells(worksheet, cellOrRange, format) {
    const regex = /([A-Z]+)(\d+)(?::([A-Z]+)(\d+))?/g;
    const rangeElements = [...cellOrRange.matchAll(regex)][0];
    const colRange = { from: rangeElements[1].split(""), to: (rangeElements[3] || rangeElements[1]).split("") };
    if (colRange.from.length === 1)
        colRange.from.unshift(" ");
    if (colRange.to.length === 1)
        colRange.to.unshift(" ");
    const rowRange = { from: parseInt(rangeElements[2]), to: parseInt(rangeElements[4] || rangeElements[2]) };
    // const superColumns = ["", "A", "B", "C"]
    // const subColumns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
    // const columns = superColumns.flatMap(supC => subColumns.map(subC => `${supC}${subC}`))
    const columns = [
        [" ", "A"],
        [" ", "B"],
        [" ", "C"],
        [" ", "D"],
        [" ", "E"],
        [" ", "F"],
        [" ", "G"],
        [" ", "H"],
        [" ", "I"],
        [" ", "J"],
        [" ", "K"],
        [" ", "L"],
        [" ", "M"],
        [" ", "N"],
        [" ", "O"],
        [" ", "P"],
        [" ", "Q"],
        [" ", "R"],
        [" ", "S"],
        [" ", "T"],
        [" ", "U"],
        [" ", "V"],
        [" ", "W"],
        [" ", "X"],
        [" ", "Y"],
        [" ", "Z"],
        ["A", "A"],
        ["A", "B"],
        ["A", "C"],
        ["A", "D"],
        ["A", "E"],
        ["A", "F"],
        ["A", "G"],
        ["A", "H"],
        ["A", "I"],
        ["A", "J"],
        ["A", "K"],
        ["A", "L"],
        ["A", "M"],
        ["A", "N"],
        ["A", "O"],
        ["A", "P"],
        ["A", "Q"],
        ["A", "R"],
        ["A", "S"],
        ["A", "T"],
        ["A", "U"],
        ["A", "V"],
        ["A", "W"],
        ["A", "X"],
        ["A", "Y"],
        ["A", "Z"],
        ["B", "A"],
        ["B", "B"],
        ["B", "C"],
        ["B", "D"],
        ["B", "E"],
        ["B", "F"],
        ["B", "G"],
        ["B", "H"],
        ["B", "I"],
        ["B", "J"],
        ["B", "K"],
        ["B", "L"],
        ["B", "M"],
        ["B", "N"],
        ["B", "O"],
        ["B", "P"],
        ["B", "Q"],
        ["B", "R"],
        ["B", "S"],
        ["B", "T"],
        ["B", "U"],
        ["B", "V"],
        ["B", "W"],
        ["B", "X"],
        ["B", "Y"],
        ["B", "Z"],
    ];
    for (let column of columns) {
        if (column[0] > colRange.to[0])
            break;
        if (column[0] == colRange.to[0] && column[1] > colRange.to[1])
            break;
        if (column[0] > colRange.from[0] || (column[0] == colRange.from[0] && column[1] >= colRange.from[1])) {
            for (let row = rowRange.from; row <= rowRange.to; row++) {
                const cell = worksheet[`${column[0]}${column[1]}${row}`.trimStart()];
                if (cell && cell.s)
                    cell.s = { ...cell.s, ...format };
                if (cell && !cell.s)
                    cell.s = format;
            }
        }
    }
}
function formatSheet(worksheet, widths, heights, ranges) {
    if (widths)
        formatColumns(worksheet, widths);
    if (heights)
        formatRows(worksheet, heights);
    if (ranges) {
        for (let range in ranges) {
            formatCells(worksheet, range, ranges[range]);
        }
    }
}

var xlsx = /*#__PURE__*/Object.freeze({
	__proto__: null,
	HEADER_CELL_FORMAT: HEADER_CELL_FORMAT,
	CURRENCY_CELL_FORMAT: CURRENCY_CELL_FORMAT,
	formatColumns: formatColumns,
	formatRows: formatRows,
	AllColumns: AllColumns,
	formatCells: formatCells,
	formatSheet: formatSheet
});

export { HEADERS, RESPONSES, Role, Roles, VENDOR_NAME_NOISE_WORDS, afterLast, asFolders, beforeLast, deClutter, doRequest, firstDateIn, format, getAuthToken, getEntityS3ObjectInfo, getFileName, getFileType, getMimeType, isNullOrEmptyOrWhitespace, isString, justText, letterPairs, pickRandom, randomPassword, replaceSuffix, sequenceBy, shuffle, sleep, stringCompare, stringToDate, stringsMatch, toISODate, xlsx };
